var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcItemMasterSubmodule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery31"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery30"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery29"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery28"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery27"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery26"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery25"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,11v8c0,0.55-0.45,1-1,1H15c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h10C25.55,10,26,10.45,26,11z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,24c0,1.65-1.35,3-3,3s-3-1.35-3-3c0-1.65,1.35-3,3-3S30,22.35,30,24z",
    fill: "#48B1DD"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,24c0,1.65-1.35,3-3,3s-3-1.35-3-3c0-1.65,1.35-3,3-3S16,22.35,16,24z",
    fill: "#48B1DD"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,20H9c-0.4658,0-0.8701-0.3213-0.9746-0.7754L5.2041,7H2C1.4473,7,1,6.5527,1,6s0.4473-1,1-1h4    c0.4658,0,0.8701,0.3213,0.9746,0.7754L9.7959,18H30c0.5527,0,1,0.4473,1,1S30.5527,20,30,20z",
    fill: "#4391B2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,8v3c0,0.55-0.45,1-1,1H14c-0.55,0-1-0.45-1-1V8c0-0.55,0.45-1,1-1h12C26.55,7,27,7.45,27,8z",
    fill: "#48B1DD"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery23"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery22"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery21"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery20"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery19"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery18"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery17"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery16"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery14"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery13"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery12"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery11"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery10"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery09"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery08"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery07"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery06"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery05"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery04"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery03"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery02"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Packaging_Delivery01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcItemMasterSubmodule);
export default __webpack_public_path__ + "static/media/ic_item_master_submodule.2ac7010ba3c0691a338901584fdf5ee6.svg";
export { ForwardRef as ReactComponent };